
export const EDIT_AUTHOR_NAME_LABEL = "Автор"

export const EDIT_AUTHOR_NAME_TEXT = "Указывается, если автор не вы, а иное лицо, предоставившее вам права на добавление мода"
